export default __webpack_public_path__ + "static/media/up-arrow-angle.bfaece9b.svg";